<template>
    <div class="card-school">
        <div class="card-school-panel">
          <a :href="greatSchoolUrl()" target="_blank" rel="nofollow" class="panel-school-rate" :aria-label="`See all reviews about ${data.name}`">
            <div class="card-school-rate" :rate="rating.rate"></div>
          </a>
          <div class="panel-info text-capitalize ">
               <a  class="link f7" :href="glb.appUrl + data.dspUrl" >{{data.name}}</a>
              <div class="f7">{{data.type}} School, {{getLevel}}</div>
              <div class="f7">GreatSchools Rating: {{getRating}}</div>
          </div>
        </div>
        <div class="card-school-footer" v-if="showFooter">
             <a  class="link" v-if="!isActive"  @click="switchSchoolBoundary" >{{molang('dpp.propertySchool.homesInSchoolZone')}}</a>
             <a  class="link" v-if="isActive"  @click="switchSchoolBoundary" >{{molang('dpp.propertySchool.removeSchoolZone')}}</a>
        </div>
    </div>
</template>

<script src="./mvt-cardschool.js"></script>

<style lang="scss">
@use "./mvt-cardschool.scss" as *;
</style>
